import { Animation } from "../../../components/Animation/Animation.tsx";
import { Button } from "../../../components/Button/Button.tsx";
import { CHARACTER_MODEL_TYPE } from "../../constants.ts";
import { useRedirectToHome } from "../../hooks/useRedirectToHome.ts";
import { useUser } from "../../hooks/useUser.ts";
import { ModelFormColumn } from "../components/ModelFormColumn.tsx";
import { useModel } from "../hooks/useModel.ts";
import { useRedirectToHomepageModels } from "../hooks/useRedirectToHomepageModels.ts";

export const TrainingModelLoadingScreen = () => {
  const { model } = useModel();
  const { user } = useUser();
  const redirectToHomepageModels = useRedirectToHomepageModels(model.uuid);
  const redirectToHome = useRedirectToHome();
  return (
    <div className="w-full h-full flex-col items-center justify-center">
      <ModelFormColumn>
        <div className="flex-col gap-800 items-center">
          <div style={{ height: 230, width: 230 }}>
            <Animation
              loadData={() => import("../../../assets/boardInitLoading.json")}
              loop
              autoplay
            />
          </div>
          <div className="flex-col gap-400 text-center text-primary">
            <div className="heading-4xl">We’re training your model</div>
            <div className="flex-col gap-500 body-lg-semibold">
              <div>
                Your model will be ready in just{" "}
                {model.type === CHARACTER_MODEL_TYPE ? 5 : 15} minutes!
              </div>
              {user?.email && (
                <div className="text-secondary">
                  We’ll notify you by email at{" "}
                  <span className="text-primary">{user.email}</span> as soon as
                  it’s ready.
                </div>
              )}
            </div>
          </div>
          <div className="flex-col gap-200">
            <Button
              variant="primary"
              size="lg"
              onClick={redirectToHomepageModels}
            >
              See my models
            </Button>
            <Button variant="secondary" size="lg" onClick={redirectToHome}>
              Back to home
            </Button>
          </div>
        </div>
      </ModelFormColumn>
    </div>
  );
};
